import SelectTypeView from './selectType.container';

export default SelectTypeView;
